import React from "react";
import lodash from "lodash";
import PATHS from "config/paths";
import { StateContext } from "state.js";


/* eslint-disable react-hooks/exhaustive-deps */

export function usePostNotificationRead(token, id = undefined) {
  const State = React.useContext(StateContext);
  const [isSuccess, setIsSuccess] = React.useState();
  const setRefresh = State.notificationsRefresh.set;
  const [markedId, setMarkedId] = React.useState();

  /**
   * Make Request
   */
  React.useEffect(() => {
    if (token && id) {
      const options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        }
      };

      const path = `${PATHS.apiNotificationsMarkRead}/${id}`;

      async function patchRequest() {
        const request = await fetch(path, options)
          .then((res) => res.text())
          .then((text) => {
            text.length ? JSON.parse(text) : {};
            setRefresh(true);
            setIsSuccess(true);
            setMarkedId(id);
          })
          .catch((error) => {
            setIsSuccess(false);
          });
      }

      patchRequest();
    }
  }, [token, id]);

  return { postNotificationReadSuccess: isSuccess, postNotificationMarkedId: markedId };
}
